(() => {
  if (customElements.get('video-media')) {
    return;
  }

  class VideoMedia extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
    }

    connectedCallback() {
      this.querySelector('.js-toggle-play').addEventListener(
        'click',
        this.toggle.bind(this),
      );
    }

    toggle() {
      this.video.paused ? this.video.play() : this.video.pause();
      this.video.paused
        ? this.classList.add('paused')
        : this.classList.remove('paused');
    }
  }

  customElements.define('video-media', VideoMedia);
})();
